// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum VehicleRegisterVehicleStatus {
  Other = "OTHER",
  Operated = "OPERATED",
  Discontinued = "DISCONTINUED",
  Decommissioned = "DECOMMISSIONED",
  Exported = "EXPORTED",
  DeletedDueToDuplication = "DELETED_DUE_TO_DUPLICATION",
}
export default VehicleRegisterVehicleStatus;

export function vehicleRegisterVehicleStatusToVariant(vehicleRegisterVehicleStatus: VehicleRegisterVehicleStatus) {
  switch (vehicleRegisterVehicleStatus) {
    case VehicleRegisterVehicleStatus.Other:
    case VehicleRegisterVehicleStatus.Exported:
      return "gray";

    case VehicleRegisterVehicleStatus.Discontinued:
    case VehicleRegisterVehicleStatus.Decommissioned:
    case VehicleRegisterVehicleStatus.DeletedDueToDuplication:
      return "danger";

    case VehicleRegisterVehicleStatus.Operated:
      return "success";
  }
}
